module.exports = __webpack_public_path__ + "static/img/c5.f9c9993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/c5.png
// module id = 81aE
// module chunks = 3